// extracted by mini-css-extract-plugin
export default {"GetDemo":"get-demo_GetDemo__F3ep5","demoLicenseAgreement":"get-demo_demoLicenseAgreement__472bM","redStar":"get-demo_redStar__8xcd1","inputBlock":"get-demo_inputBlock__Vqkf+"};